export const defaultValues = {
  room: null,
  name: null,
  address: null,
  appType: null,
  area: null,
  
  // Lo-Fi Master Data
  latitude: null,
  longitude: null
};
